/**
 * 路由名称枚举
 */
export const RouteName = {
  Home: 'Home',
  Login: 'Login',
  FirstAccess: 'FirstAccess',
  Welcome: 'Welcome',
  Wizard: 'Wizard',
  ResetPassword: 'ResetPassword',
  FirstAccessLogin: 'FirstAccessLogin',
  Employees: 'Employees',
  Users: 'Users',
  User: 'User',
  Employee: 'Employee',
  EmployeeMassCreditPolicy: 'EmployeeMassCreditPolicy',
  CompanyFinancialConfig: 'CompanyFinancialConfig',
  CompanyDetail: 'CompanyDetail',
  CreateCompany: 'CreateCompany',
  EditCompany: 'EditCompany',
  Company: 'Company',
  CompanyGroup: 'CompanyGroup',
  CostCenters: 'CostCenters',
  CostCenter: 'CostCenter',
  Projects: 'Projects',
  UsagePolicies: 'UsagePolicies',
  UsagePolicy: 'UsagePolicy',
  CreditPolicies: 'CreditPolicies',
  Incentives: 'Incentives',
  IncentivesBulkOperation: 'IncentivesBulkOperation',
  Reports: 'Reports',
  ConsolidatedReports: 'ConsolidatedReports',
  ConsolidatedReport: 'ConsolidatedReport',
  Receipts: 'Receipts',
  ManualRetrieval: 'ManualRetrieval',
  Financial: 'Financial',
  FinancialAdjustments: 'FinancialAdjustments',
  ImportNfe: 'ImportNfe',
  Revenues: 'Revenues',
  RevenuesNfeImport: 'RevenuesNfeImport',
  NfeImportHistory: 'NfeImportHistory',
  RideCredit: 'RideCredit',
  InvoiceExtendDueDate: 'InvoiceExtendDueDate',
  ApprovePayment: 'ApprovePayment',
  InvoiceExtendDueDateSoldOutRequests: 'InvoiceExtendDueDateSoldOutRequests',
  InvoiceExtendDueDateExpiredRequests: 'InvoiceExtendDueDateExpiredRequests',
  ApprovePaymentBulkOperation: 'ApprovePaymentBulkOperation',
  SearchPhonePage: 'SearchPhonePage',
  AccessProfilesPage: 'AccessProfilesPage',
  AccessProfilesDetailsPage: 'AccessProfilesDetailsPage',
  WebCall: 'WebCall',
  WebCall_old: 'WebCall_old',
  CostCenterBulkOperation: 'CostCenterBulkOperation',
  EmployeeBulkOperation: 'EmployeeBulkOperation',
  ProjectBulkOperation: 'ProjectBulkOperation',
  TokenRequest: 'TokenRequest',
  BuyRideCoupon: 'BuyRideCoupon',
  Debug: 'Debug',
  UnavailablePage: 'UnavailablePage',
  ExpiredLink: 'ExpiredLink',
  CheckLink: 'CheckLink',
  Highcharts: 'Highcharts',
  EntregaCall: 'EntregaCall',
  EntregaOrders: 'EntregaOrders',

  // v4
  HelpCenter: 'HelpCenter',
  EmployeeDetail: 'EmployeeDetail',
  RideDetail: 'RideDetail',
  CostCenterDetail: 'CostCenterDetail',
  NoMenuPage: 'NoMenuPage'
}

/**
 * 路由路径配置
 * 以RouteName为key，包含v3Path和v4Path
 */
export const RoutePath = {
  [RouteName.Home]: {
    v3Path: '/',
    v4Path: '/',
    useV4: true,
    menuKey: '/'
  },
  [RouteName.Login]: {
    v3Path: '/login',
    v4Path: '/login',
    menuKey: '/login',
    noMenu: true,
    noHeader: true
  },
  [RouteName.FirstAccess]: {
    v3Path: '/primeiro-acesso/colaborador/:employeeId/token/:token',
    v4Path: '/primeiro-acesso/colaborador/:employeeId/token/:token'
  },
  [RouteName.Welcome]: {
    v3Path: '/bem-vindo',
    v4Path: '/bem-vindo',
    noMenu: true
  },
  [RouteName.Wizard]: {
    v3Path: '/wizard',
    v4Path: '/wizard',
    noMenu: true
  },
  [RouteName.ResetPassword]: {
    v3Path: '/redefinir-senha/:token',
    v4Path: '/redefinir-senha/:token'
  },
  [RouteName.FirstAccessLogin]: {
    v3Path: '/primeiro-acesso/:token',
    v4Path: '/primeiro-acesso/:token'
  },

  [RouteName.Users]: {
    v3Path: '/usuarios',
    v4Path: '/users',
    menuKey: '/users'
  },
  [RouteName.User]: {
    v3Path: '/usuario/:type/:id?',
    v4Path: '/usuario/:type/:id?',
    menuKey: '/users'
  },
  [RouteName.Employees]: {
    v3Path: '/colaboradores/:id?',
    v4Path: '/employees',
    menuKey: '/employees',
    useV4: true
  },
  [RouteName.Employee]: {
    v3Path: '/colaborador/:type/:id?',
    v4Path: '/employee',
    menuKey: '/employees',
    useV4: true
  },
  [RouteName.EmployeeMassCreditPolicy]: {
    v3Path: '/politica-de-credito-em-massa',
    v4Path: '/employee/mass-credit-policy',
    menuKey: '/employees'
  },
  [RouteName.CompanyFinancialConfig]: {
    v3Path: '/configuracoes/empresa/:id/financeiro',
    v4Path: '/settings/company/:id/financial',
    menuKey: '/settings/company'
  },
  [RouteName.CompanyDetail]: {
    v3Path: '/configuracoes/empresa/:id/detalhamento',
    v4Path: '/settings/companyDetail',
    useV4: true,
    menuKey: '/settings/company'
  },
  [RouteName.CreateCompany]: {
    v3Path: '/configuracoes/empresa/cadastrar/:id?',
    v4Path: '/settings/company/create/:id?',
    useV4: true,
    menuKey: '/settings/company'
  },
  [RouteName.EditCompany]: {
    v3Path: '/configuracoes/empresa/editar/:id?',
    v4Path: '/settings/company/edit/:id?',
    useV4: true,
    menuKey: '/settings/company'
  },
  [RouteName.Company]: {
    v3Path: '/configuracoes/empresa',
    v4Path: '/settings/companyList',
    useV4: true,
    menuKey: '/settings/company'
  },
  [RouteName.CompanyGroup]: {
    v3Path: '/configuracoes/grupo-de-empresa/:type/:id?',
    v4Path: '/configuracoes/grupo-de-empresa/:type/:id?',
    menuKey: '/settings/company'
  },
  [RouteName.CostCenters]: {
    v3Path: '/configuracoes/centros-de-custo/:id?',
    v4Path: '/settings/cost-center',
    menuKey: '/settings/cost-center'
  },
  [RouteName.CostCenter]: {
    v3Path: '/configuracoes/centro-de-custo/:type/:id?',
    v4Path: '/configuracoes/centro-de-custo/:type/:id?',
    menuKey: '/settings/cost-center'
  },
  [RouteName.Projects]: {
    v3Path: '/configuracoes/projetos/:id?/:type?',
    v4Path: '/settings/projects',
    menuKey: '/settings/projects'
  },
  [RouteName.UsagePolicies]: {
    v3Path: '/configuracoes/politicas-de-uso',
    v4Path: '/settings/usage-policy',
    menuKey: '/settings/usage-policy'
  },
  [RouteName.UsagePolicy]: {
    v3Path: '/configuracoes/politica-de-uso/:type/:id?',
    v4Path: '/settings/usage-policy/:type/:id?',
    menuKey: '/settings/usage-policy'
  },
  [RouteName.CreditPolicies]: {
    v3Path: '/configuracoes/politicas-de-credito',
    v4Path: '/settings/credit-policy',
    menuKey: '/settings/credit-policy'
  },
  [RouteName.Incentives]: {
    v3Path: '/configuracoes/incentivos',
    v4Path: '/settings/incentives',
    menuKey: '/settings/incentives'
  },
  [RouteName.IncentivesBulkOperation]: {
    v3Path: '/importacao-em-massa/incentivos/:id?',
    v4Path: '/importacao-em-massa/incentivos/:id?'
  },
  [RouteName.Reports]: {
    v3Path: '/relatorios/:type?',
    v4Path: '/reports',
    useV4: true,
    menuKey: '/reports'
  },
  [RouteName.ConsolidatedReports]: {
    v3Path: '/relatorios-consolidados/:action?/:id?',
    v4Path: '/relatorios-consolidados/:action?/:id?',
    menuKey: '/reports'
  },
  [RouteName.ConsolidatedReport]: {
    v3Path: '/relatorio-consolidado',
    v4Path: '/relatorio-consolidado',
    menuKey: '/reports'
  },
  [RouteName.Receipts]: {
    v3Path: '/recibo-de-corridas',
    v4Path: '/receipts',
    noMenu: true,
    noHeader: true,
    useV4: true
  },
  [RouteName.Financial]: {
    v3Path: '/financeiro/historico-de-faturas',
    v4Path: '/financial/invoice-history',
    menuKey: '/financial/invoice-history'
  },
  [RouteName.FinancialAdjustments]: {
    v3Path: '/financeiro/ajustes-financeiros',
    v4Path: '/financial/finance-adjustment',
    menuKey: '/financial/finance-adjustment'
  },
  [RouteName.ManualRetrieval]: {
    v3Path: '/financeiro/recobranca-manual',
    v4Path: '/financial/manual-recovery'
  },
  [RouteName.ImportNfe]: {
    v3Path: '/financeiro/bg2-imortar-nfe',
    v4Path: '/financial/b2g-import-nfe',
    menuKey: '/financial/b2g-import-nfe'
  },
  [RouteName.Revenues]: {
    v3Path: '/financeiro/faturamento',
    v4Path: '/financial/issue-invoice',
    menuKey: '/financial/issue-invoice'
  },
  [RouteName.RevenuesNfeImport]: {
    v3Path: '/financeiro/faturamento/importar-nfes',
    v4Path: '/financeiro/faturamento/importar-nfes',
    menuKey: '/financial/issue-invoice'
  },
  [RouteName.NfeImportHistory]: {
    v3Path: '/financeiro/faturamento/historico',
    v4Path: '/financeiro/faturamento/historico',
    menuKey: '/financial/issue-invoice'
  },
  [RouteName.ApprovePayment]: {
    v3Path: '/financeiro/aprovar-pagamento',
    v4Path: '/financial/approve-payment',
    menuKey: '/financial/approve-payment'
  },
  [RouteName.RideCredit]: {
    v3Path: '/financeiro/credito-de-corrida/:type?/:id?',
    v4Path: '/financeiro/credito-de-corrida/:type?/:id?'
  },
  [RouteName.InvoiceExtendDueDate]: {
    v3Path: '/financeiro/fatura/prorrogar-vencimento/:invoiceId?/:dueDateOpt?',
    v4Path: '/financeiro/fatura/prorrogar-vencimento/:invoiceId?/:dueDateOpt?'
  },
  [RouteName.InvoiceExtendDueDateSoldOutRequests]: {
    v3Path: '/financeiro/fatura/solicitacoes-esgotadas',
    v4Path: '/financeiro/fatura/solicitacoes-esgotadas'
  },
  [RouteName.InvoiceExtendDueDateExpiredRequests]: {
    v3Path: '/financeiro/fatura/prorrogacao-expirada/:date',
    v4Path: '/financeiro/fatura/prorrogacao-expirada/:date'
  },
  [RouteName.ApprovePaymentBulkOperation]: {
    v3Path: '/importacao-em-massa/aprovar-pagamento/:id?',
    v4Path: '/importacao-em-massa/aprovar-pagamento/:id?'
  },
  [RouteName.SearchPhonePage]: {
    v3Path: '/buscar-telefone',
    v4Path: '/mobile-search',
    useV4: true,
    menuKey: '/mobile-search'
  },
  [RouteName.AccessProfilesPage]: {
    v3Path: '/perfis',
    v4Path: '/perfis'
  },
  [RouteName.AccessProfilesDetailsPage]: {
    v3Path: '/perfis/:id?',
    v4Path: '/perfis/:id?'
  },
  [RouteName.WebCall]: {
    v3Path: '/nova-chamada-web',
    v4Path: '/web-call',
    menuKey: '/web-call'
  },
  [RouteName.WebCall_old]: {
    v3Path: '/chamada-web',
    v4Path: '/chamada-web',
    menuKey: '/web-call'
  },
  [RouteName.CostCenterBulkOperation]: {
    v3Path: '/importacao-em-massa/centro-de-custo/:id?',
    v4Path: '/importacao-em-massa/centro-de-custo/:id?'
  },
  [RouteName.EmployeeBulkOperation]: {
    v3Path: '/importacao-em-massa/colaboradores/:id?',
    v4Path: '/importacao-em-massa/colaboradores/:id?'
  },
  [RouteName.ProjectBulkOperation]: {
    v3Path: '/importacao-em-massa/projetos/:id?',
    v4Path: '/importacao-em-massa/projetos/:id?'
  },
  [RouteName.TokenRequest]: {
    v3Path: '/solicitar-token',
    v4Path: '/request-token'
  },
  [RouteName.BuyRideCoupon]: {
    v3Path: '/99cupons',
    v4Path: '/99cupons'
  },
  [RouteName.Debug]: {
    // 调试用，不用管
    v3Path: '/debug',
    v4Path: '/debug'
  },
  [RouteName.UnavailablePage]: {
    v3Path: '/sistema-indisponivel',
    v4Path: '/sistema-indisponivel'
  },
  [RouteName.ExpiredLink]: {
    v3Path: '/link-expirado',
    v4Path: '/link-expirado'
  },
  [RouteName.CheckLink]: {
    v3Path: '/verificar-link',
    v4Path: '/verificar-link'
  },
  [RouteName.Highcharts]: {
    v3Path: '/highcharts',
    v4Path: '/highcharts'
  },
  [RouteName.EntregaCall]: {
    v3Path: '/entregaCall',
    v4Path: '/delivery-service',
    menuKey: '/delivery-service'
  },
  [RouteName.EntregaOrders]: {
    v3Path: '/entregaOrders',
    v4Path: '/delivery-orders',
    menuKey: '/delivery-orders'
  },
  // v4
  [RouteName.HelpCenter]: {
    v3Path: '/',
    v4Path: '/help-center',
    useV4: true,
    menuKey: '/help-center'
  },
  [RouteName.EmployeeDetail]: {
    v3Path: '/',
    v4Path: '/employee/:id',
    useV4: true,
    menuKey: '/employees'
  },
  [RouteName.RideDetail]: {
    v3Path: '/',
    v4Path: '/ride/:id',
    useV4: true
  },
  [RouteName.CostCenterDetail]: {
    v3Path: '/',
    v4Path: '/cost-center/:id',
    useV4: true,
    menuKey: '/cost-center'
  },
  [RouteName.NoMenuPage]: {
    v3Path: '/noMenuPage',
    v4Path: '/noMenuPage',
    menuKey: '/noMenuPage'
  }
}

export const RoutePathV4 = Object.entries(RoutePath).reduce((acc, [key, value]) => {
  return {
    ...acc,
    [key]: value.v4Path
  }
}, {})

export const RoutePathV3 = Object.entries(RoutePath).reduce((acc, [key, value]) => {
  return {
    ...acc,
    [key]: value.v3Path
  }
}, {})

export const getV4Path = (routeName, to) => {
  const { params, query } = to || {}
  let v4Path = RoutePathV4[routeName]
  if (v4Path?.endsWith('?')) {
    v4Path = v4Path.slice(0, -1)
  }
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      console.log('key', key, 'value', value)
      v4Path = v4Path.replace(`:${key}`, value)
    })
  }
  if (query && Object.keys(query).length > 0) {
    const queryParams = []

    Object.keys(query).forEach(key => {
      queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(query[key] || '')}`)
    })

    if (queryParams.length > 0) {
      v4Path += `?${queryParams?.join('&')}`
    }
  }
  console.log('v4Path', v4Path)
  return v4Path
}
